export const SET_USER = "SET_USER";
export const RESET_USER = "RESET_USER";
export const CLEAR_USER_SELECTED_CRC = "CLEAR_USER_SELECTED_CRC";
